<template>
  <div class="new1bg" style="background-color: #F3F3F3">
    <img class="img-bg" :src="require(`@/assets/images/${newsData.mainImgSrc}`)" v-if="newsData.mainImgSrc" />
    <div class="new1contentbg" :class="newsStyle.style === 0 ? 'new1contentbg0':'new1contentbg1'" :style="newsStyle.style === 0 ? 'background-color: rgba(0, 0, 0, 0.54)':'background-color: rgba(0, 0, 0, 0)'">
      <div class="new1title ellipsis-2" v-text="newsData.title" :class="newsStyle.style === 0 ? 'title0color':'title1color'"/>
      <div class="new1time" v-text="newsData.time" :class="newsStyle.style === 0 ? 'new1time-color0':'new1time-color1' "/>
      <div class="new1content ellipsis-3" v-text="newsData.desc" :class="newsStyle.style === 0 ? 'content0color':'content1color'"/>
    </div>
  </div>

</template>
<script>

export default {
  name: "New1",
  props:{
    newsData:{
      type:Object,
      default:{
        title:"",
        time:"",
        desc:"",
        mainImgSrc:""
      }
    },
    newsStyle:{
      type:Object,
      default:{
        style:0
      }
    },
  },
  setup(){

    return{
      // testX
    }
  },
  methods:{
    testX(data) {
      return require(`./../assets/images/${data}`);
    }
  }
};
</script>

<style scoped>
.new1bg {
  background-size: cover;
  position: relative;
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
}
.img-bg{
  width: 100%;
  height: 100%;
}

.new1contentbg{
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 160px;
  box-sizing: border-box;
}

.new1contentbg1 {
  padding: 0 12px 18px 12px;
}

.new1contentbg0 {
  padding: 18px 12px 18px 12px;
}


.new1title {
  font-size: 20px;
  color: white;
}

.new1time {
  font-size: 16px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 28px;
}

.new1time-color0{
  color: white;
}

.new1time-color1{
  color: #00A0E9;
}

.title0color{
  color: white;
}
.title1color{
  color: #333333;
}
.content0color{
  color: white;
}
.content1color{
  color:#666666;
}

.new1content {
  margin-top: 5px;
  font-size: 16px;
  height: 70px;
}
</style>
